'use client'

import createWidget from '@/widgets/create-widget'
import LearningPedagogySectionSchema, {
  learningPedagogy,
  LearningPedagogySectionDefaultValues,
  LearningPedagogySectionProps,
} from './schema'
import { PhotoIcon } from '@heroicons/react/24/solid'
import LearningPedagogySection from '@/components/RevampedLanding/LearningPedagogySection'
import { JSX } from 'react'

export function LearningPedagogySectionWidget(props: learningPedagogy) {
  const { learningPedagogySection } = props

  return <LearningPedagogySection learningPedagogyData={learningPedagogySection} />
}
export default createWidget<learningPedagogy>({
  formType: LearningPedagogySectionSchema,
  render(props): JSX.Element {
    return <LearningPedagogySectionWidget {...props} />
  },
  id: 'Landing.Page.LearningPedagogySection',
  name: 'Landing Learning Pedagogy Section',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: LearningPedagogySectionDefaultValues,
})
